import axios from 'axios';
import { VERSION } from '../constant';
import axiosRetry from 'axios-retry';
import isRetryAllowed from 'is-retry-allowed';
// import mpAdapter from 'axios-miniprogram-adapter';
// import getPlatform from './getPlatform';
// const { isAliPayMiniProgram, isWeixinMiniProgram } = getPlatform();
const instance = axios.create({
    timeout: 15000,
    headers: {
        'sdk-version': VERSION,
    },
});
// if (isAliPayMiniProgram || isWeixinMiniProgram) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// instance.defaults.adapter = mpAdapter;
// }
axiosRetry(instance, {
    retries: 3,
    retryCondition: (error) => isRetryAllowed(error),
    shouldResetTimeout: true,
    retryDelay: (retryCount) => {
        return retryCount * 3000; // 重复请求延迟（毫秒）
    },
});
instance.interceptors.response.use((response) => {
    return response === null || response === void 0 ? void 0 : response.data;
});
export default instance;
//# sourceMappingURL=request.js.map